class PrMentionsSwiper {
  constructor() {
    this.sliders = document.querySelectorAll("[data-pr-mentions-slider]");

    if (!this.sliders.length || typeof Swiper === "undefined") {
      return;
    }

    this.init();
  }

  init() {
    this.sliders.forEach((slider) => {
      const loop = slider.dataset.loop === "true";
      const speed = parseInt(slider.dataset.speed || "7000", 10);
      const spaceBetween = parseInt(slider.dataset.spaceBetween || "40", 10);
      const pauseOnHover = slider.dataset.pauseHover === "true";
      const reverseDirection = slider.dataset.reverse === "true";
      const slidesDesktop = parseInt(slider.dataset.slidesDesktop || "5", 10);
      const slidesMobile = parseInt(slider.dataset.slidesMobile || "2", 10);

      new Swiper(slider, {
        allowTouchMove: true,
        centeredSlides: false,
        freeMode: false,
        grabCursor: true,
        loop,
        slidesPerView: slidesMobile,
        spaceBetween,
        speed,
        watchSlidesProgress: true,
        breakpoints: {
          990: {
            slidesPerView: slidesDesktop
          }
        },
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: pauseOnHover,
          reverseDirection
        }
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new PrMentionsSwiper();
});
